import { createStyles, getStylesRef, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  header: {
    paddingTop: 17,
    paddingBottom: theme.spacing.md,
    marginBottom: `calc(${theme.spacing.md} * 1.5)`,
    background: "red",
  },
  control: {
    fontWeight: 500,
    display: "block",
    width: "100%",
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    fontSize: theme.fontSizes.sm,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[7]
          : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.white : theme.black,
    },
  },
  footer: {
    paddingTop: theme.spacing.md,
    marginTop: theme.spacing.md,
  },

  link: {
    ...theme.fn.focusStyles(),
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    flexWrap: "nowrap",
    fontSize: rem(20),
    color: "#667085",
    // border: "1px solid red",
    // color:
    //   theme.colorScheme === "dark"
    //     ? theme.colors.dark[1]
    //     : theme.colors.gray[7],
    padding: "5px 10px",
    borderRadius: 4,
    fontWeight: 500,
    marginBottom: theme.spacing.sm,
    "&:hover": {
      borderRadius: 4,
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.white : theme.black,

      [`& .${getStylesRef("icon")}`]: {
        color: theme.colorScheme === "dark" ? theme.white : theme.black,
      },
    },
  },
  linkClose: {
    ...theme.fn.focusStyles(),
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    flexWrap: "nowrap",
    fontSize: rem(20),
    // border: "1px solid red",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[1]
        : theme.colors.gray[7],
    padding: "5px 20px",
    borderRadius: "50%",
    fontWeight: 500,
    marginBottom: theme.spacing.sm,
    "&:hover": {
      borderRadius: 4,
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.white : theme.black,

      [`& .${getStylesRef("icon")}`]: {
        color: theme.colorScheme === "dark" ? theme.white : theme.black,
      },
    },
  },

  drawerClosedLink: {
    padding: "0 8px",
    // borderRadius: 50,
  },

  linkIcon: {
    ref: getStylesRef("icon"),
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[2]
        : theme.colors.gray[6],
    marginRight: theme.spacing.sm,
  },

  linkActive: {
    "&, &:hover": {
      backgroundColor: "#53389E",
      borderRadius: 4,
      color: "#FFF",
      [`& .${getStylesRef("icon")}`]: {
        color: "#FFF",
        // background: "white",
      },
    },
  },
  linkActiveClose: {
    "&, &:hover": {
      backgroundColor: "#53389E",
      borderRadius: "50%",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "35px",
      height: "35px",
      [`& .${getStylesRef("icon")}`]: {
        color: "#FFF",
        // background: "white",
      },
    },
  },
  chevron: {
    transition: "transform 200ms ease",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    flex: 1,
  },
  iconsStyle: {
    position: "relative",
    left: "20px",
  },
  label:{
    width: "max-content",
    fontFamily: "Inter",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0%",
  }
}));

export default useStyles;
